<div class="close-button">
	<button class="close" (click)="close()"><i class="fal fa-times"></i></button>
</div>
<header>
	<h1 class="title" translate>removeEntity.title</h1>
</header>

<mat-dialog-content>
	{{ 'removeEntity.message.' + type | translate : { name: name } }}
</mat-dialog-content>

<mat-dialog-actions>
	<div class="row btn-group">
		<div class="col-12 p-0">
			<btn-loading btnClass="btn btn-danger content-btn-danger" type="button" (click)="remove()"
				[loading]="loading" loadingText="{{ 'removeEntity.loadingMessage' | translate }}">
				<div class="content-button">
					<span>{{ 'removeEntity.actionButton' | translate }}</span>
					<i class="far fa-trash ml-2"></i>
				</div>
			</btn-loading>

			<button type="button" (click)="close()" class="btn btn-sm content-btn-primary">
				<div class="content-button" translate>removeEntity.cancelButton</div>
			</button>
		</div>
	</div>
</mat-dialog-actions>